const darkModeCheckbox = document.querySelector(".theme-toggle__checkbox");

const setDarkModeCookie = () => {
    if (darkModeCheckbox) {
        darkModeCheckbox.addEventListener('change', function(e) {
            if (darkModeCheckbox.checked) {
                window.localStorage.setItem('unifiedDarkMode', 'true');
            } else {
                window.localStorage.setItem('unifiedDarkMode', 'false');
            }
        });
    }
}

const determineDarkModeSetting = () => {
    if (window.localStorage.getItem('unifiedDarkMode') && window.localStorage.getItem('unifiedDarkMode') == 'true') {
        let themeToggleCheckbox = document.querySelector(".theme-toggle__checkbox");
        if (themeToggleCheckbox) {
            themeToggleCheckbox.click();
        }
    }
}

const main = () => {
    determineDarkModeSetting();
    setDarkModeCookie();
}

export default main;